<template>
  <div>
    <template-header />
    <breadcrumb-header />
    <div class="wrapper">
      <template-sidebar :active="namePath" />
      <div id="content">
        <router-view />
      </div>
    </div>
    <b-modal v-model="showTimer" no-close-on-esc no-close-on-backdrop>
      <template #modal-header="">
        <h5>{{ $t("label_sessionAboutToExpire_warning_title") }}</h5>
      </template>
      <div>
        {{ $t("label_sessionAboutToExpire_warning_mainMessage") }}
        {{ formattedExpirationDate }}
      </div>
      <template #modal-footer="">
        <b-button variant="primary" @click="touchToken()">
          {{ $t("label_sessionAboutToExpire_warning_staySignedIn_button") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showErrorsModal" no-close-on-esc no-close-on-backdrop>
      <template #modal-header="">
        <h5>Lo sentimos, han occurrido los siguientes errores</h5>
      </template>
      <div>
        Es posible que la página no se visualice correctamente debido a los
        siguientes errores:
      </div>
      <ul>
        <li v-for="(error, errorIndex) of getAllErrors" :key="errorIndex">
          {{ error }}
        </li>
      </ul>
      <template #modal-footer="">
        <b-button size="sm" variant="primary" @click="dismissErrors()">
          Cerrar
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="selectRoleModal" no-close-on-esc no-close-on-backdrop>
      <template #modal-header="">
        <h5>Selección de Role</h5>
      </template>
      <div>Por favor seleccione el role con el que desea hacer login</div>
      <template-role-selector />
      <template #modal-footer="">
        <span />
      </template>
    </b-modal>
<!--    <button @click="migrate()">migrate</button>-->
  </div>

</template>

<script>
// import { USER_REQUEST } from '../store/actions/user'
import "../components/template/_globals";
import "../components/cards/_globals";
import { mapGetters } from "vuex";
import moment from "moment";
import TemplateRoleSelector from "../components/template/_template-role-selector";
import { axiosCall } from "../utils/axiosCall";
import BreadcrumbHeader from "../components/template/_template-breadcrumb-header";

export default {
  name: "App",
  components: { TemplateRoleSelector, BreadcrumbHeader },
  data: function () {
    return {
      namePath: "",
      selectRoleModal: false,
      showErrorsModal: false,
      showTimer: false,
      expirationDate: null,
      formattedExpirationDate: null,
    };
  },
  watch: {
    getTokenExpirationDate: function (newValue) {
      this.expirationDate = newValue;
      this.startCountDown();
    },
    getCurrentAccountRoleId: {
      handler: function () {
        this.displayRoleSelection();
      },
      deep: true,
    },
    getUserAccountRoles: {
      handler: function () {
        this.displayRoleSelection();
      },
      deep: true,
    },
    getAllErrors: {
      handler: function () {
        this.showErrorsModal = this.getAllErrors.length > 0;
      },
      deep: true,
    },
  },
  beforeDestroy() {
    clearInterval();
  },
  methods: {
    migrate(){
      axiosCall({ url: "/Evidences/copy/63e5759d242eb3036d8ee795/65ad9f2fe14d5388139f6fc6", method: "GET" })

    },
    startCountDown() {
      clearInterval();
      setInterval(() => {
        this.getExpirationTime();
      }, 1000);
    },
    touchToken() {
      axiosCall({ url: "UserAccounts/touch", method: "GET" });
    },
    zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    getExpirationTime() {
      if (this.expirationDate) {
        let remainingSeconds = Math.floor(
          moment(this.expirationDate).diff(moment(), "seconds")
        );
        if (remainingSeconds < 300) {
          this.showTimer = true;
          const minutes = moment(this.expirationDate).diff(moment(), "minutes");
          const seconds =
            moment(this.expirationDate).diff(moment(), "seconds") -
            minutes * 60;
          this.formattedExpirationDate = `${minutes}:${this.zeroPad(
            seconds,
            2
          )}`;
          if (remainingSeconds < 0) {
            remainingSeconds = 0;
          }
          if (remainingSeconds === 0) {
            this.showTimer = false;
            this.$store.commit("setTokenExpirationDate", null);
            this.$store.commit("setTokenExpired", true);
            clearInterval();
            this.$router.push("/");
          }
        } else {
          this.showTimer = false;
        }
      }
    },
    dismissErrors() {
      this.$store.dispatch("dismissAllErrors");
    },
    displayRoleSelection() {
      if (!this.getUserAccountRoles?.length || this.getCurrentAccountRoleId) {
        this.selectRoleModal = false;
      } else {
        this.selectRoleModal = true;
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    ...mapGetters([
      "getTokenExpirationDate",
      "getAllErrors",
      "getCurrentAccountRoleId",
      "getUserAccountRoles",
    ]),
  },
  created: function () {
    this.displayRoleSelection(this.$store.getters.getCurrentAccountRoleId);
  },
};
</script>

<style lang="scss">
/* containers/private */
@import "../assets/css/variables.scss";
.wrapper {
  display: flex;
  align-items: stretch;

  #content {
    min-height: 100vh;
    transition: all 0.3s;
    width: 100vw;
  }
}
.bars,
.bars2 {
  font: 10px sans-serif;
}
.bullet {
  cursor: pointer;
  .marker {
    stroke: $actual-color;
    stroke-width: 4px;
  }
  .ideal {
    stroke: $ideal-color;
    stroke-width: 2px;
  }
  .tick {
    line {
      stroke: #666;
      stroke-width: 0.5px;
    }
    text {
      font-size: 0.6rem;
    }
  }
  .measure {
    &.s0 {
      fill: lightsteelblue;
    }
    &.s1 {
      fill: steelblue;
    }
  }
  .see-more {
    fill: blue;
    font-size: 0.7rem;
  }
}
.gridCircle {
  stroke-width: 1px;
}
.legend {
  font-family: $font-text;
  fill: #333333;
}
.tooltip {
  font-family: $font-text;
  fill: #333333;
}

.treemap-node {
  font-family: $font-text;
  border: solid 1px white;
  font: 10px sans-serif;
  line-height: 12px;
  overflow: hidden;
  position: absolute;
  text-indent: 2px;
  padding: 5px;
  cursor: pointer;

  h4 {
    font-size: 1.5rem;
    text-align: center;
  }
  p {
    font-size: 0.7rem;
  }
}
.self-assesment {
  font-size: 1.1rem;

  fieldset {
    border: 2px solid #ddd;
    padding: 10px;
    border-radius: 10px;
    margin-top: 4rem;
    margin-bottom: 2rem;
    &.employment {
      margin-top: 1rem;
    }
    &.compact {
      .col-md-1 {
        padding-left: 0px;
      }
      .col,
      .col-3,
      .col-6 {
        padding-left: 2px;
        padding-right: 2px;
      }
    }
    .title {
      color: $primary-color;
      font-size: 1.5rem;
      text-transform: uppercase;
      font-weight: bolder;
      line-height: 1.1;
      font-family: $font-subtitle;
    }
  }
  .header {
    position: relative;
    margin-top: 0px;
    text-align: center;

    .icon {
      position: absolute;
      top: -60px;
      right: calc(50% - 50px);
      border-radius: 100%;
      width: 100px;
      height: 100px;
      background-color: $accent-color;
      padding: 15px;
      img {
        width: 70px;
        height: 70px;
      }
    }
    h4 {
      font-size: 1rem;
      margin-top: 25px;
      margin-bottom: 0px;
    }
    h2 {
      margin-top: 25px;
      color: $primary-color;
      font-size: 1.5rem;
      text-transform: uppercase;
    }
    &.work-policies {
      margin-top: 20px;
      .status {
        top: -25px;
      }
    }
  }
  .label {
    width: 100%;
    background-color: $primary-color;
    padding: 5px;
    text-align: center;
    color: white;
    border-radius: 2px;
    margin-bottom: 5px;
    font-size: 1.1rem;
  }
  .row.table-header {
    margin-bottom: 5px;
    p {
      background-color: $secondary-color;
      color: white;
      width: 100%;
      padding: 0px;
      margin-bottom: 0;
      text-align: center;
      border-radius: 2px;
      margin-bottom: 0px;
      font-size: 1.1rem;
    }
  }
  .form-group {
    margin-bottom: 5px;
    margin-top: 5px;
    p {
      text-align: right;
    }
    .form-control {
      text-align: center;
      padding: 5px;
      text-align-last: center;
    }
  }
  .employment-policies {
    min-height: 4.5rem;
    .index {
      display: flex;
      text-align: center;
      background-color: $accent-color;
      color: white;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      border-radius: 15px;
      position: absolute;
      left: -22px;
      margin: 0;
      top: 0;
      font-size: 1.2rem;
    }
    .question {
      text-align: left;
      margin-left: 30px;
      margin-bottom: 0px;
      line-height: 1.4rem;
    }
  }
  .custom-control {
    margin-right: 0rem;
  }
  .subtotal {
    background-color: #ddd;
    padding: 5px 0;
    margin-left: -10;
    margin-right: -10;
    text-align: center;
    color: #111;
    p {
      margin-top: 8px;
      margin-bottom: 0px;
    }
  }
  .policy-exists {
    text-align: center;
  }
  .other-custom-ethnic-identity::placeholder {
    color: #a5a3b2;
    font-style: italic;
  }
}
.box {
  border: 1px solid $primary-color;
  border-radius: 15px;
  padding: 2rem;
  margin-top: 15px;
}

.bullet-container {
  font-family: $font-text;
}
.pdf-container {
  .card {
    .card-text {
      font-size: 0.9rem;
      margin-bottom: 0.4rem;
    }
    .card-title {
      margin-bottom: 0.4rem;
    }
  }
}
.snapshot-selectors {
  display: flex;
  font-weight: bold;
  .col-form-label {
    color: $primary-color;
    text-align: right;
  }
}
@media (max-width: 768px) {
  .self-assesment {
    font-size: 0.9rem;
    .row.table-header p {
      font-size: 0.9rem;
    }
  }
  .snapshot-selectors {
    .col-form-label {
      display: none;
    }
    .col-sm-6,
    .col-sm-9 {
      max-width: 95%;
      flex: 0 0 95%;
    }
  }
}
@media (max-width: 540px) {
  .snapshot-selectors {
    position: initial;
    margin-top: 10px;
  }
}

.terms-modal {
  .modal-body {
    height: 85vh;
    overflow: scroll;
  }
  .custom-control-description {
    margin-left: 10px;
  }
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0,0,0,.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.labor-conditions {
  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 50px;
    height: 25px;
    border: 1px solid #aaa;
    border-radius: 2px;
    background: #ebebeb;
    position: relative;
    display: inline-block;
    overflow: hidden;
    vertical-align: middle;
    transition: background 0.3s;
    box-sizing: border-box;
  }
  input[type="checkbox"]:after {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    height: 25px;
    width: 24px;
    background: white;
    border: 1px solid #aaa;
    border-radius: 2px;
    transition: left 0.1s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  }
  input[type="checkbox"]:checked {
    background-color: #47a447;
    border-color: #398439;
  }
  input[type="checkbox"]:checked:after {
    left: 24px;
    border-color: #398439;
    height: 25px;
    width: 24px;
  }

  input[type="checkbox"]:hover:not(:checked):not(:disabled):after,
  input[type="checkbox"]:focus:not(:checked):not(:disabled):after {
    left: 0px;
  }

  input[type="checkbox"]:hover:checked:not(:disabled):after,
  input[type="checkbox"]:focus:checked:not(:disabled):after {
    left: 22px;
  }

  input[type="checkbox"]:disabled {
    opacity: 0.5;
  }
}
</style>
